import { BaseModel } from '@core/data-access';
import { Expose } from 'class-transformer';

export class SubmitLoanDto extends BaseModel {
  @Expose() quoteId!: number;
  @Expose() loanAmount!: number;
  @Expose() term!: number;
  @Expose() total!: number;
  @Expose() interest!: number;
  @Expose() holdback!: number;
}
